module.exports = __webpack_public_path__ + "static/media/listView.723a5043.svg";